var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { billDefaultDate } from "../../../helper/defaultDate";
import { getDateAtZeroPoint } from '../../../helper/dateUtil';
import PurchaseService from '../../../api/PurchaseService';
function getInitFormData() {
    var initFormData = {
        time_type: '1',
        order_status: [1, 2, 3],
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
        depot_ids: [],
        keyword: '',
        keyword_type: 1
    };
    return initFormData;
}
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, getInitFormData());
        _this.type = [
            {
                id: 1,
                label: "计划单号"
            },
            {
                id: 2,
                label: "订货单号"
            },
            {
                id: 3,
                label: "货品"
            },
        ];
        _this.placeHolderObj = {
            1: '请输入计划单号',
            2: '请输入订货单号',
            3: '请输入货品',
        };
        _this.timeType = [
            {
                label: "制单时间",
                value: "1"
            },
            {
                label: "审核时间",
                value: "2"
            },
            {
                label: "到货时间",
                value: "3"
            }
        ];
        _this.options = [
            {
                id: -1,
                label: "全部状态"
            },
            {
                id: 1,
                label: "待审核"
            },
            {
                id: 2,
                label: "已审核"
            },
            {
                id: 3,
                label: "已完成"
            },
            {
                id: 5,
                label: "已废弃"
            },
        ];
        _this.isMoreSearch = false;
        _this.treeData = [];
        _this.startPickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        return _this;
    }
    BillHeader.prototype.watch_s_time = function (newValue, oldValue) {
        this.endPickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var start = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() < start.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    BillHeader.prototype.watch_e_time = function (newValue, oldValue) {
        this.startPickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var end = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() > end.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    BillHeader.prototype.created = function () {
        this.service = PurchaseService.getInstance();
    };
    BillHeader.prototype.mounted = function () {
        this.getOrgandepotOptions();
        this.search();
    };
    BillHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
        window._czc.push(["_trackEvent", '采购计划', '采购计划查询']);
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, getInitFormData());
        window._czc.push(["_trackEvent", '采购计划', '采购计划查询重置']);
    };
    BillHeader.prototype.getOrgandepotOptions = function () {
        var _this = this;
        this.service.getOrgandepotOptions().then(function (res) {
            if (res.data.success) {
                var data = res.data.data.map(function (item) {
                    var children = item.children && item.children.length > 0 && item.children.map(function (child) {
                        return __assign({}, child);
                    });
                    return __assign({}, item, { depot_id: item.organ_id + '_organ_id', depot_name: item.organ_name, children: children });
                });
                _this.treeData = data;
            }
        });
    };
    BillHeader.prototype.moreSearchComShow = function () {
        this.isMoreSearch = true;
    };
    BillHeader.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
    };
    BillHeader.prototype.normalizer = function (node) {
        return {
            id: node.depot_id,
            label: node.depot_name,
            children: node.children,
        };
    };
    __decorate([
        Watch("formData.s_time", { immediate: true })
    ], BillHeader.prototype, "watch_s_time", null);
    __decorate([
        Watch("formData.e_time", { immediate: true })
    ], BillHeader.prototype, "watch_e_time", null);
    BillHeader = __decorate([
        Component({
            components: {}
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
